export default function TemplateLead({ data, color }) {
  if (data?.field_display_block[0]?.value == 1) {
    return (
      <div className={'template-lead'}>
        <span>{data?.field_template_lead_text[0]?.value}</span>
        <hr style={{ backgroundColor: color }} />
      </div>
    );
  } else {
    return null;
  }
}
